var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", { on: { currentGroup: _vm.currentGroupFunc } }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5 mt-7",
              attrs: { cols: "12", align: "center" },
            },
            [
              _vm.viewCount == 4
                ? _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-2",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pr-2",
                              attrs: { cols: "6", align: "right" },
                            },
                            _vm._l(2, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0 mb-4",
                                  attrs: { id: "camera_4box", cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "camera_select_btn",
                                        cols: "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            width: "9rem",
                                            height: "2rem",
                                            id: "blue_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cameraSelect(
                                                index,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.tsg("selectCamera")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 ellipsis",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        id: "camera_select_bottom_bar",
                                        cols: "12",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s("cameraName") + " ")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-2",
                              attrs: { cols: "6", align: "left" },
                            },
                            _vm._l(2, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0 mb-4",
                                  attrs: { id: "camera_4box", cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "camera_select_btn",
                                        cols: "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            width: "9rem",
                                            height: "2rem",
                                            id: "blue_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cameraSelect(
                                                index + 2,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.tsg("selectCamera")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 ellipsis",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        id: "camera_select_bottom_bar",
                                        cols: "12",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s("cameraName") + " ")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewCount == 9
                ? _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 pl-1 pr-1",
                          attrs: { align: "center" },
                        },
                        _vm._l(3, function (item, index) {
                          return _c(
                            "v-col",
                            {
                              key: index,
                              staticClass: "ma-0 pa-0 pr-1 pl-1",
                              attrs: { cols: "4" },
                            },
                            _vm._l(3, function (item_nest, index_nest) {
                              return _c(
                                "v-col",
                                {
                                  key: index_nest,
                                  staticClass: "ma-0 pa-0 mb-2",
                                  attrs: { id: "camera_9box", cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "camera_select_btn",
                                        cols: "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            width: "9rem",
                                            height: "2rem",
                                            id: "blue_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cameraSelect(
                                                index_nest + 3 * index,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.tsg("selectCamera")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 ellipsis",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        id: "camera_select_bottom_bar",
                                        cols: "12",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s("cameraName") + " ")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewCount == 16
                ? _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-2",
                          attrs: { align: "center" },
                        },
                        _vm._l(4, function (item, index) {
                          return _c(
                            "v-col",
                            {
                              key: index,
                              staticClass: "ma-0 pa-0 pl-1 pr-1",
                              attrs: { cols: "3" },
                            },
                            _vm._l(4, function (item_nest, index_nest) {
                              return _c(
                                "v-col",
                                {
                                  key: index_nest,
                                  staticClass: "ma-0 pa-0 mb-2",
                                  attrs: { id: "camera_16box", cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "camera_select_btn",
                                        cols: "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            width: "8rem",
                                            height: "2rem",
                                            id: "blue_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cameraSelect(
                                                index_nest + 4 * index,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.tsg("selectCamera")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 ellipsis",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        id: "camera_select_bottom_bar",
                                        cols: "12",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s("cameraName") + " ")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mt-3 mb-7", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: {
                            width: "9rem",
                            height: "2rem",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.pagePop },
                        },
                        [_vm._v(" " + _vm._s(_vm.t("cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0 ml-3",
                          attrs: {
                            width: "9rem",
                            height: "2rem",
                            id: "blue_btn",
                            elevation: "0",
                            loading: _vm.createLoading,
                          },
                          on: { click: _vm.goSplitScreen },
                        },
                        [_vm._v(" " + _vm._s(_vm.t("create")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CameraSearchDialog", {
        attrs: {
          dialogVisible: _vm.cameraSearchDialogVisible,
          storeListData: _vm.storeList,
          checkBoxVisible: _vm.checkable,
          storeInGroupData: _vm.currentGroup,
        },
        on: {
          visible: _vm.cameraSearchDialogVisibleFunc,
          selectedCamera: _vm.modifySelectedCameraFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }